import { API_BASE_URL } from "../config";
import { getFirebaseAuth } from "./firebase";

// Firebaseの認証トークンを返す
async function getIdTokenIfSignedIn() {
  const auth = await getFirebaseAuth();
  const user = auth.currentUser;
  if (!user) return null;
  return user.getIdToken();
}

export async function authorizedFetch(path, options = {}) {
  const headers = { ...(options.headers || {}) };

  // 認証トークンを取ってくる
  const token = await getIdTokenIfSignedIn();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(path, { ...options, headers });
  // const res = await fetch(`${API_BASE_URL}${path}`, {
  //   ...options,
  //   headers,
  // });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`[${res.status}] ${text}`);
  }
  return res.json();
}

// 来場者一覧取得
export function fetchVisitors(eventDate, eventTableKey) {
  const params = {};
  if (eventDate) params.eventDate = eventDate;
  // if (eventName) params.eventName = eventName;
  if (eventTableKey) params.eventTableKey = eventTableKey

  const qs = new URLSearchParams(params).toString();
  const suffix = qs ? `?${qs}` : "";
  return authorizedFetch(`/api/event/visitors${suffix}`);
}

// 来場者検索
export function fetchVisitorByCode({ encodedSynergyId, eventDate, eventTableKey }) {
  const id = (encodedSynergyId || "").toString().trim();
  if (!id) throw new Error("encodedSynergyId is required");

  const dateKey = (eventDate || "").toString().trim();
  if (!dateKey) throw new Error("eventDate is required");

  const eventKey = (eventTableKey || "").toString().trim();
  if (!eventKey) throw new Error("eventTableKey is required");

  const params = {
    encodedSynergyId: id,
    eventDate: dateKey,
    eventTableKey: eventKey,
  };
  const qs = new URLSearchParams(params).toString();
  const suffix = qs ? `?${qs}` : "";
  return authorizedFetch(`/api/event/lookup${suffix}`);
}

// 来場受付
export function postEventCheckin({ encodedSynergyId, eventTableKey, eventName, historyId, note }) {
  const id = (encodedSynergyId || "").toString().trim();
  if (!id) throw new Error("encodedSynergyId is required");

  const eventKey = (eventTableKey || "").toString().trim();
  if (!eventKey) throw new Error("eventTableKey is required");

  return authorizedFetch("/api/event/checkin", {
    method: "POST",
    headers: { "Content-Type": "application/json", },
    body: JSON.stringify({
      encodedSynergyId: id,
      eventTableKey: eventKey,
      eventName,
      historyId,
      note,
    }),
  });
}